<template>
  <div class="publishPage">
    <div class="headerWrapper">
      <img
        class="img"
        :src="`${this.uploadUrl}/file/view/` + form.pushCoverImageId"
        alt=""
      />
    </div>
    <div class="mainContainer">
      <div class="mainContent">
        <div class="mainTitle">{{ form.title }}</div>
        <div class="mainDigest">
          {{ form.remark }}
          <div class="imgcontainer">
            <img :src="form.newsName" alt="" />
          </div>
        </div>
        <div class="mainRemark">
          <!-- <div class="ql-editor" v-html="form.text" style="padding: 10px"></div> -->
          <quill-editor
            ref="myQuillEditor"
            v-model="form.text"
            :options="editorOption"
            :disabled="true"
          ></quill-editor>
        </div>
        <div class="footerContainer">
          <div class="content">
            <span>附件 <img src="@/assets/newsNotice/link.png" alt="" /></span>
            <span style="color: #4ea27c" @click="accessoryLink"
              >附件链接查看</span
            >
          </div>
          <div class="content">
            <span>原文链接</span>
            <span style="color: #4ea27c" @click="jumpTextLink"
              >原文链接查看</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/apis/medal";
import { Base64 } from "js-base64";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
export default {
  name: "publishPage",
  data() {
    return {
      form: {},
      remark: "",
      uploadUrl: "",
      editorOption: {
        modules: {
          toolbar: ""
        }
      }
    };
  },
  created() {
    this.uploadUrl = api.uploadUrl;
  },
  mounted() {
    //获取新闻公告详情
    api.newsDetail(this.$route.query.id).then(res => {
      if (res.code === 200) {
        this.form = res.data;
        this.form.newsName =
          this.form.newsType == 1
            ? require("@/assets/newsNotice/rongguang.png")
            : this.form.newsType == 2
            ? require("@/assets/newsNotice/xingguang.png")
            : this.form.newsType == 3
            ? require("@/assets/newsNotice/liuguang.png")
            : "";
      }
    });
  },
  methods: {
    //获取附件链接
    accessoryLink() {
      let pptName = this.form.fileName.replace(/&|=|\?|\\/g, '')
      var url = `http://qw.nvc-lighting.com.cn:8083/file/view/${this.form.fileId}?fullfilename=${pptName}`; //要预览文件的访问地址
      window.open(
        "http://qw.nvc-lighting.com.cn:10000/onlinePreview?url=" +
          encodeURIComponent(Base64.encode(url))
      );
    },
    //跳转原文链接
    jumpTextLink() {
      if (this.form.link.indexOf("http") !== -1) {
        this.form.link = "http" + this.form.link.split("http")[1];
      }
      if (this.form.link.indexOf("https") !== -1) {
        this.form.link = "https" + this.form.link.split("https")[1];
      }
      this.form.link
        ? window.open(this.form.link)
        : this.$notify({ type: "primary", message: "暂无链接" });
    }
  }
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
// @import './news.css';
@media screen and (max-width: 600px) {
  .publishPage {
    width: 100%;
  }
  .mainRemark {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  .publishPage {
    width: 276px * $zoom;
  }
  .mainRemark {
    width: 276px * $zoom;
  }
}
.publishPage {
  .headerWrapper {
    .img {
      width: 100%;
      height: 445px;
    }
  }
  .mainContainer {
    position: relative;
    top: -60px;
    z-index: 9999;
    background-color: #fff;
    border-radius: 50px 50px 0 0;
    .mainContent {
      padding: 50px 20px 0 20px;
      .mainTitle {
        display: flex;
        justify-content: center;
        font-size: 29px;
        font-weight: 600;
        margin-bottom: 40px;
      }
      .mainDigest {
        font-size: 26px;
        color: #c4c5c4;
        margin-bottom: 50px;
        position: relative;
        .imgcontainer {
          position: absolute;
          top: -40px;
          right: 0;
          z-index: 9999;
          img {
            width: 214px;
            height: 172px;
          }
        }
      }
      ::v-deep .mainRemark {
        // border: 1px solid #f1f1f1;
        border-radius: 12px;
        margin-bottom: 30px;
        img {
          width: 100%;
          height: 100%;
        }
        iframe {
          width: 100%;
          height: 100%;
        }
        .ql-editor {
          min-height: 350px;
        }
        .ql-container.ql-snow {
          border-radius: 12px;
          border-color: #f1f1f1;
        }
      }
      .footerContainer {
        font-size: 29px;
        font-weight: 400;
        .content {
          display: flex;
          justify-content: space-between;
          margin-bottom: 40px;
          img {
            width: 28px;
            height: 28px;
          }
        }
      }
    }
  }
}
</style>
